export default {
    bindings: {
        loading: '<',
        guests: '<'
    },
    controller: 'orderCreateTabsController',
    template: require('../views/basket.create.tabs.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/basket.create.tabs.component.js